import {
  reviewFemaleConnieImage,
  reviewFemaleLisaImage,
  reviewFemaleSofiaImage,
  reviewMaleDevidImage,
  reviewMaleLucasImage,
  reviewMaleMarkImage,
} from '@src/assets/images';

import { IReviewHears } from '../interfaces/reviews.interfaces';
import { GENDER } from './questions.constants';

export const REVIEWS = [
  {
    id: 1,
    title: 'socials.plan.reviews.1.title',
    author: 'socials.plan.reviews.1.author',
    text: 'socials.plan.reviews.1.text',
  },
  {
    id: 2,
    title: 'socials.plan.reviews.2.title',
    author: 'socials.plan.reviews.2.author',
    text: 'socials.plan.reviews.2.text',
  },
  {
    id: 3,
    title: 'socials.plan.reviews.3.title',
    author: 'socials.plan.reviews.3.author',
    text: 'socials.plan.reviews.3.text',
  },
  {
    id: 4,
    title: 'socials.plan.reviews.4.title',
    author: 'socials.plan.reviews.4.author',
    text: 'socials.plan.reviews.4.text',
  },
  {
    id: 5,
    title: 'socials.plan.reviews.5.title',
    author: 'socials.plan.reviews.5.author',
    text: 'socials.plan.reviews.5.text',
  },
];

export const REVIEWS_HEARS: IReviewHears[] = [
  {
    id: 1,
    author: 'Mark S.',
    text: 'reviewsHears.list.1',
    start: '96.7 kg',
    finish: '71.9 kg',
    picture: reviewMaleMarkImage,
    gender: GENDER.MALE,
  },
  {
    id: 2,
    author: 'David P.',
    text: 'reviewsHears.list.2',
    start: '108 kg',
    finish: '75 kg',
    picture: reviewMaleDevidImage,
    gender: GENDER.MALE,
  },
  {
    id: 3,
    author: 'Lucas R.',
    text: 'reviewsHears.list.3',
    start: '113.5 kg',
    finish: '72.1 kg',
    picture: reviewMaleLucasImage,
    gender: GENDER.MALE,
  },
  {
    id: 4,
    author: 'Lisa S.',
    text: 'reviewsHears.list.4',
    start: '97 kg',
    finish: '64 kg',
    picture: reviewFemaleLisaImage,
    gender: GENDER.FEMALE,
  },
  {
    id: 5,
    author: 'Connie P.',
    text: 'reviewsHears.list.5',
    start: '98 kg',
    finish: '61 kg',
    picture: reviewFemaleConnieImage,
    gender: GENDER.FEMALE,
  },
  {
    id: 6,
    author: 'Sofia R.',
    text: 'reviewsHears.list.6',
    start: '106 kg',
    finish: '67.1 kg',
    picture: reviewFemaleSofiaImage,
    gender: GENDER.FEMALE,
  },
];
